import { take, fork, call, put } from 'redux-saga/effects';
import formActions, { FormActionTypes } from '../actions/form-actions';
import { submitForm } from '../utilities/form-utility';

/**
 * @generator _submitForm
 * Private method to submit formData to backend
 * @param { String } key form's key
 * @param { Object } options form's options
 * @param { Object } formData formData
 */
function* _submitForm(key, { action }, formData) {
  try {
    yield call(submitForm, action, formData);
    yield put(formActions.submitFormComplete({ key }));
  } catch (error) {
    yield put(formActions.submitFormError({ key, error }));
  }
}

export default function* forms() {
  while (true) {
    const { type, payload } = yield take([
      FormActionTypes.SUBMIT_FORM,
    ]);

    switch (type) {
      case FormActionTypes.SUBMIT_FORM:
        yield fork(_submitForm, payload.key, payload.options, payload.formData);
        break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/sagas/forms-saga.js